import { SESSION_ID, SESSION_TIME, SESSION_STEP, INCOMPLETE_SESSION_STEP, SESSION_PASSKEY_REGISTRATION_STEP, PASSKEY_REGISTRATION_TIME } from '@/constants'

const generateUUID = (): string => {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  // Fallback for environments where crypto.randomUUID is not available (e.g. Android 12 WebView)
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  bytes[6] = (bytes[6] & 0x0f) | 0x40 // version 4
  bytes[8] = (bytes[8] & 0x3f) | 0x80 // variant 1
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

export const getSessionId = (): string | undefined => {

  let sessionId = localStorage.getItem(SESSION_ID)

  if (!sessionId) {
    try {
      sessionId = generateUUID()
      localStorage.setItem(SESSION_ID, sessionId)
    } catch {}


  }

  return sessionId

}

export const getIncompleteStep = (): string | undefined => {

  const step = localStorage.getItem(INCOMPLETE_SESSION_STEP)

  return step ? step : ''

}

export const saveIncompleteStep = (step: string): void => {

  localStorage.setItem(INCOMPLETE_SESSION_STEP, step)

}

export const clearIncompleteStep = () => {
  localStorage.removeItem(INCOMPLETE_SESSION_STEP)
}

export const getCurrentStep = (): string | undefined => {

  const step = localStorage.getItem(SESSION_STEP)

  return step ? step : ''

}

export const saveCurrentStep = (step: string): void => {

  localStorage.setItem(SESSION_STEP, step)

}

export const getPasskeyRegistrationCurrentStep = (): string | undefined => {

  const step = localStorage.getItem(SESSION_PASSKEY_REGISTRATION_STEP)

  return step ? step : ''

}

export const saveSessionStart = () => {
  localStorage.setItem(SESSION_TIME, Date.now().toString())
}

export const getSessionStartTime = () => {
  const sessionStartTime = localStorage.getItem(SESSION_TIME)

  return sessionStartTime
}

export const clearSessionStep = () => {
  localStorage.removeItem(SESSION_STEP)
}

export const clearSessionTracker = () => {
  localStorage.removeItem(SESSION_ID)
  localStorage.removeItem(SESSION_TIME)
  localStorage.removeItem(SESSION_STEP)
  localStorage.removeItem(SESSION_PASSKEY_REGISTRATION_STEP)
}


export const savePasskeyRegistrationCurrentStep = (step: string): void => {
  localStorage.setItem(SESSION_PASSKEY_REGISTRATION_STEP, step)
}

export const savePasskeyRegistrationTime = (): void => {

  const startTime = getSessionStartTime()

  localStorage.setItem(PASSKEY_REGISTRATION_TIME, startTime)
}

export const getPasskeyRegistrationStartTime = () => {

  const passkeyRegistrationStartTime = localStorage.getItem(PASSKEY_REGISTRATION_TIME)

  return passkeyRegistrationStartTime
}

